import type { FormApi } from 'final-form';
import { validateInn } from '@alfa-bank/site-helpers-form/validation/inn';

import type { IFieldValidators } from '../models';

// кастомный валидатор формы, так как встроенного у final-form не найдено
export const validateForm = (form: FormApi) => () =>
    form.getRegisteredFields().every(field => {
        const state = form.getFieldState(field);

        return !!(state && state.valid);
    });

export const fieldValidators: IFieldValidators = {
    default: () => '',
    inn: validateInn(),
};
